import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import Button from "../Button";
import { SingleDatePicker } from "react-dates";
import moment from "moment";

export default function UpdateDueDates({ sampleIds, onApply }) {
  const [date, setDate] = useState(null);
  const [focused, setFocused] = useState(false);

  const handleSubmit = () => {
    if (sampleIds.length === 0 || !date) return;
    if (!confirm("Are you sure you want to update the due dates of these samples?")) return;
    var url = "/registration/samples/update_due_dates";
    post(url, {
      sample_ids: sampleIds,
      day: date.date(),
      month: date.month() + 1,
      year: date.year(),
    })
      .then((json) => {
        onApply();
        alert("Due dates were updated");
      })
      .catch((e) => alert(e));
  };

  return (
    <div className="row" style={{ maxWidth: 800 }}>
      <div className="col-md-12">
        <p>
          {sampleIds.length} samples selected: {sampleIds.join(", ")}{" "}
        </p>
        Select due date:
        <SingleDatePicker
          numberOfMonths={1}
          date={date}
          onDateChange={(date) => setDate(date)}
          focused={focused}
          onFocusChange={({ focused }) => setFocused(focused)}
          id="date"
          showClearDate={false}
          isOutsideRange={() => false}
          displayFormat="DD MMM YYYY"
        />
        <br />
        <br />
        <Button
          onClick={handleSubmit}
          title={"Update Due Dates of Selected Samples"}
          primary
          disabled={sampleIds.length == 0 || !date}
          style={{ height: 38 }}
        />
      </div>
    </div>
  );
}
